import React from "react";
import Hero from "./Hero";
import BlogsList from "./BlogsList";
import { blogData } from "./utils";

function Blog() {
  return (
    <div>
      <Hero />
      <BlogsList blogs = {blogData}/>
    </div>
  );
}

export default Blog;
